import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 24 * 60 * 60;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownBar() {
  const [remaining, setRemaining] = useState<number>(TOTAL_SECONDS - 3);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const units: Array<{
    value: number;
    suffix: string;
  }> = [{
    value: Math.floor(remaining / 3600),
    suffix: 'hrs'
  }, {
    value: Math.floor(remaining % 3600 / 60),
    suffix: 'min'
  }, {
    value: remaining % 60,
    suffix: 'sec'
  }];
  return <div className="sticky top-0 z-50 w-full bg-orange-600 text-white" data-id="element-33" data-mp="28gfc074exzz9">
      <div className="mx-auto flex max-w-5xl items-center justify-center gap-2 px-4 py-2 text-[11px] font-bold uppercase tracking-[0.14em] sm:text-xs" data-id="element-34" data-mp="ant8w2huvxwn">
        <HourglassIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-35" data-mp="13e0lc2765u52" />
        <span data-id="element-36" data-mp="13cftwlg5irbf">Launch offer ends in:</span>
        <span className="flex items-center gap-1 tabular-nums" aria-live="off" data-id="element-37" data-mp="18cu1619xhx8e">
          {units.map((unit, index) => <span key={unit.suffix} className="flex items-center gap-1" data-id="element-38" data-mp="ue45mq2rc5m5" data-mpi={index}>
              <span className="text-sm font-bold sm:text-base" data-id="element-39" data-mp="yeo01lvy4v4l">
                {pad(unit.value)}
              </span>
              <span className="text-[9px] tracking-normal text-orange-100" data-id="element-40" data-mp="1m48je5w0huee">
                {unit.suffix}
              </span>
              {index < units.length - 1 && <span className="px-0.5 text-orange-200" data-id="element-41" data-mp="1dc6lae9f0q7a">:</span>}
            </span>)}
        </span>
      </div>
    </div>;
}